import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd17632c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout-main" }
const _hoisted_3 = { class: "layout-left" }
const _hoisted_4 = { class: "layout-right" }
const _hoisted_5 = { class: "layout-right-breadcrumb" }
const _hoisted_6 = { class: "layout-right-page" }
const _hoisted_7 = {
  key: 0,
  class: "exclusive-waiter"
}
const _hoisted_8 = { class: "exclusive-waiter-header" }
const _hoisted_9 = { class: "exclusive-waiter-header-detail" }
const _hoisted_10 = { class: "text-header" }
const _hoisted_11 = { style: {"word-break":"keep-all"} }
const _hoisted_12 = { style: {"word-break":"keep-all"} }
const _hoisted_13 = { class: "detailContent" }

import leftMenu from './components/leftMenu.vue'
import layoutHeader from './components/header.vue'
import { ArrowRight, Avatar } from '@element-plus/icons-vue'
import { ref, onMounted, getCurrentInstance } from 'vue'
import { useMainStore } from '@/stores/main'
import { storeToRefs } from 'pinia'
import { useRoute } from 'vue-router'
import { getMeInfo, getPermission } from '@/api/myProfile'
import { IMenuParams } from '@/types/myProfile'
import { ElMessage } from 'element-plus'
import { findIndex } from '@/utils/common'
import { getWaiterDetail } from '@/api/common'
import { getApplicationTypeTitle, getBreadcrumbTitle } from '@/utils/lang'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const isWaiter = ref(false)
const waiterDetailInfo = ref({
  email: '',
  mobile: '',
  name: '',
  surname: '',
  wechat: '',
  username: ''
})
const { t, locale } = getCurrentInstance()?.appContext.config.globalProperties.$i18n
// 对话框
const dialogVisible = ref(false)
// 面包屑、菜单
const store = useMainStore()
const { breadcrumb, menuInfo, filterMenu, activeMenu, activePage, businessTypeId } = storeToRefs(store)
const compoundSurname = '欧阳、上官、司马、诸葛、公孙、长孙、司徒、呼延、尉迟、东方、皇甫、令狐、诸葛、申屠、夏侯、贺兰、完颜、慕容、尉迟、长孙\n'

// 菜单收缩
// const isFold = ref<boolean>(false)
// const isFoldFun = (val: any) => {
//   isFold.value = val
// }
// 过滤隐藏菜单
const filterHiddenMenu = (data: any) => {
  if (!data) return []
  return data.filter((item: any) => {
    if (item.meta.status === 1) {
      item.children = filterHiddenMenu(item.children)
    }
    return item.meta.status === 1
  })
}

// 获取菜单信息
const getMenuInfo = async () => {
  await getPermission().then(async (res: any) => {
    if (res.code === 200) {
      const menu: IMenuParams[] = res.data && res.data.menu ? [...res.data.menu] : []
      filterMenu.value = await flattenMenuFun(res.data.menu)
      menuInfo.value = await filterHiddenMenu(menu)
      let path = ''
      if (route.path.split('/').length < 5) {
        path = route.path
      } else {
        const index = findIndex(route.path, '/', 3)
        path = route.path.slice(0, index)
      }
      // 当前选中一级菜单active和面包屑
      // console.log(filterMenu.value, 'aaaaaaaaaaaaa')
      for (let i = 0; i < filterMenu.value.length; i++) {
        const element: any = filterMenu.value[i]
        // console.log(path, element.path, 'bbbbbbbbbbbb', route.name, element.name)
        if (path === element.path || route.name === element.name) {
          // 业务列表排序
          activeMenu.value = element.breadcrumbList[0].name
          businessTypeId.value = element.breadcrumbList[0].application_type_id
          breadcrumb.value = element.breadcrumbList
          activePage.value = element.breadcrumbList.length > 3 ? element.breadcrumbList[2].name : element.name
          break
        }
      }
    } else {
      ElMessage(res.msg)
    }
  })
}
//
const leftMenuRef = ref(null)
const onFlodMenu = () => {
  leftMenuRef.value?.onShowFlodIcon()
}
onMounted(async () => {
  if (store.menuInfo && !store.menuInfo.length) {
    getMenuInfo()
  }
  getWaiter()
})
// 查询客服信息
const getWaiter = async () => {
  const res = await getWaiterDetail()
  // console.log('查询客服信息res', res)
  if (res.data.name) {
    isWaiter.value = true
    waiterDetailInfo.value.email = res.data.email
    waiterDetailInfo.value.mobile = res.data.mobile
    waiterDetailInfo.value.name = res.data.name
    waiterDetailInfo.value.wechat = res.data.wechat
    // 处理中文名字
    if (compoundSurname.includes(res.data.name.slice(0, 2))) {
      waiterDetailInfo.value.surname = res.data.name.substring(0, 2)
    } else if (hasNoChinese(res.data.name)) {
      // 处理英文名字
      if (res.data.name.includes('')) {
        const enName = res.data.name.split(' ')
        // console.log('分割后的enName', enName)
        waiterDetailInfo.value.surname = enName[enName.length - 1]
      } else {
        waiterDetailInfo.value.surname = res.data.name
      }
    } else {
      // 处理中文名字
      waiterDetailInfo.value.surname = res.data.name.substring(0, 1)
    }
  }
  const resMe = await getMeInfo()
  waiterDetailInfo.value.username = resMe.data.username
}
// 是否包含汉字
const hasNoChinese = (str: string) => {
  return !/[\u4E00-\u9FA5]/.test(str)
}

// 扁平化菜单
const filterMenuList: any = []
const flattenMenuFun = async (menu: any, bread?: any) => {
  for (let i = 0; i < menu.length; i++) {
    const element = menu[i]
    if (!element.breadcrumbList) {
      element.breadcrumbList = []
    }
    if (bread) {
      element.breadcrumbList.push(...bread)
    }
    element.meta.name = element.name // 用作头部默认选中
    element.meta.reload = true
    // 记录菜单相关业务application_type_id，进行业务列表页排序
    element.meta.application_type_id = element.application_type_id
    element.breadcrumbList.push(element.meta)
    if (element.children) {
      await flattenMenuFun(element.children, element.breadcrumbList)
    } else {
      filterMenuList.push(element)
    }
  }
  return filterMenuList
}


return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(layoutHeader, { onOnFlodMenu: onFlodMenu }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(leftMenu, {
          ref_key: "leftMenuRef",
          ref: leftMenuRef
        }, null, 512)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_breadcrumb, { "separator-icon": _unref(ArrowRight) }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumb), (item, index) => {
                return (_openBlock(), _createBlock(_component_el_breadcrumb_item, { key: index }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getBreadcrumbTitle)(item,_unref(t))), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["separator-icon"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (isWaiter.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_el_button, {
                  class: _normalizeClass(_unref(locale) === 'zh_CN'? 'btn-zhCn': 'btn-en'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (dialogVisible.value = true))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(_unref(locale) === 'zh_CN'? 'btn-content': 'btn-content-en')
                    }, [
                      _createVNode(_unref(Avatar), {
                        color: "#4491FF",
                        style: {"width":"17px","height":"17px","margin-top":"-1px"}
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('common.exclusiveWaiter')), 1)
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["class"]),
                _createVNode(_component_el_dialog, {
                  modelValue: dialogVisible.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
                  title: _unref(t)('common.exclusiveWaiter'),
                  "align-center": "",
                  width: "30%",
                  style: {"min-width":"500px"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t('common.dear')) + _toDisplayString(waiterDetailInfo.value.username) + _toDisplayString(_ctx.$t('common.colon')), 1),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('common.myRole')) + _toDisplayString(waiterDetailInfo.value.surname) + _toDisplayString(_ctx.$t('common.waiterDetail')), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('common.mobilePhoneOrWechat')) + " " + _toDisplayString(_ctx.$t('common.colon')) + " " + _toDisplayString(waiterDetailInfo.value.mobile), 1),
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t('myProfile.email')) + " " + _toDisplayString(_ctx.$t('common.colon')) + " " + _toDisplayString(waiterDetailInfo.value.email), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "title"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_router_view)
        ])
      ])
    ])
  ]))
}
}

})